package gr.tech.GRAttestation.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.styles.grstyles.Theme
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

val StorePaginationStyle = CssStyle {
    cssRule(" .page-link") {
        Modifier.color(Theme.DarkGreen.rgb)
    }
    cssRule(" .page-item.active .page-link") {
        Modifier
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .border(1.px, LineStyle.Solid, Theme.DarkGreen.rgb)
    }
    cssRule(" .page-link:hover") {
        Modifier
            .backgroundColor(Theme.GreenTint.rgb)
            .color(Theme.DarkGreen.rgb)
    }
    cssRule(" .page-link:focus") {
        Modifier.styleModifier {
            property("box-shadow", "0 0 0 0.2rem rgba(27, 94, 32, 0.25)")
        }
    }
}

@Composable
fun StorePaginationControls(
    currentPage: Int,
    totalPages: Int,
    onPageSelected: (Int) -> Unit,
) {
    Nav(attrs = StorePaginationStyle.toModifier().toAttrs()) {
        Ul(
            attrs = Modifier
                .classNames("pagination")
                .margin(0.px)
                .toAttrs()
        ) {
            Li(
                attrs = Modifier
                    .classNames("page-item")
                    .thenIf(currentPage <= 1, Modifier.classNames("disabled"))
                    .toAttrs()
            ) {
                A(
                    href = "#",
                    attrs = Modifier.classNames("page-link")
                        .onClick {
                            it.preventDefault()
                            if (currentPage > 1) onPageSelected(currentPage - 1)
                        }
                        .toAttrs()
                ) { Text("Previous") }
            }

            (1..totalPages).forEach { page ->
                Li(
                    attrs = Modifier
                        .classNames("page-item")
                        .thenIf(page == currentPage, Modifier.classNames("active"))
                        .toAttrs()
                ) {
                    A(
                        href = "#",
                        attrs = Modifier.classNames("page-link")
                            .onClick {
                                it.preventDefault()
                                if (page != currentPage) onPageSelected(page)
                            }
                            .toAttrs()
                    ) { Text(page.toString()) }
                }
            }

            Li(
                attrs = Modifier
                    .classNames("page-item")
                    .thenIf(currentPage >= totalPages, Modifier.classNames("disabled"))
                    .toAttrs()
            ) {
                A(
                    href = "#",
                    attrs = Modifier.classNames("page-link")
                        .onClick {
                            it.preventDefault()
                            if (currentPage < totalPages) onPageSelected(currentPage + 1)
                        }
                        .toAttrs()
                ) { Text("Next") }
            }
        }
    }
}
